import { Injectable } from '@angular/core';
import { NativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

@Injectable()
export class FrenchDateAdapter extends NativeDateAdapter {
  
  override getFirstDayOfWeek(): number {
    return 1; // Lundi comme premier jour de la semaine
  }

  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return super.format(date, displayFormat);
  }

  override parse(dateString: any): Date | null {
    // Si c'est déjà un objet Date, le retourner
    if (dateString instanceof Date) {
      return dateString;
    }

    if (!dateString || typeof dateString !== 'string') {
      return null;
    }

    const trimmedValue = dateString.trim();
    
    if (trimmedValue.length === 0) {
      return null;
    }

    // Support pour les formats DD/MM/YYYY, DD/MM/YY, D/M/YYYY, D/M/YY
    const dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/;
    const match = trimmedValue.match(dateRegex);
    
    if (match) {
      const firstPart = parseInt(match[1], 10);
      const secondPart = parseInt(match[2], 10);
      let year = parseInt(match[3], 10);
      
      // Logique pour déterminer jour/mois
      // Si le premier nombre > 12, c'est forcément le jour
      // Si le deuxième nombre > 12, c'est forcément le mois
      // Sinon, on suppose format DD/MM
      let day: number;
      let month: number;

      if (firstPart > 12) {
        // Format DD/MM
        day = firstPart;
        month = secondPart;
      } else if (secondPart > 12) {
        // Format MM/DD (détecté automatiquement)
        day = secondPart;
        month = firstPart;
      } else {
        // Les deux sont <= 12, on suppose DD/MM
        day = firstPart;
        month = secondPart;
      }
      
      // Validation
      if (day < 1 || day > 31 || month < 1 || month > 12) {
        return null;
      }
      
      // Si l'année est sur 2 chiffres, ajouter 2000
      if (year < 100) {
        year += 2000;
      }
      
      // Créer la date
      const date = new Date(year, month - 1, day, 0, 0, 0, 0);
      
      // Vérifier que la date est valide
      if (date.getFullYear() === year && 
          date.getMonth() === month - 1 && 
          date.getDate() === day) {
        return date;
      }
    }
    
    return null;
  }
}